export default {
  addressblacklist: {
    value: [
      '0x7b97b46D35a28B561d47F50CFB9a2735E506e59d',
      '0x409ad08cc6CA757f69Fb80250a424B9eFeB99807',
      '0x02A86f51aA7B8b1c17c30364748d5Ae4a0727E23',
      '0x64131b60502C01362639CC5cfE1a1efB6Be1165A',
      '0x34e56Cf8D2a392f67D6F88100896B82eD3147709',
      '0x8e9572b067E0ed9e395e64eE38FDd4697A14fc7A',
      '0xe0EF0bAA61FEBEc356aB5Abcf3c090aD40629207',
      '0x9E73d3f1b4233E6B5d6224B9234Cd26f98274904',
    ],
  },
  badroutewarnings: {
    value: {},
  },
  blacklistedwithdrawaladdress: {
    value: {
      '0x2791bca1f2de4661ed88a30c99a7a9449aa84174': 'USDC.e - Polygon',
      '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8': 'USDC.e - Arbitrum',
      '0x7f5c764cbc14f9669b88837ca1490cca17c31607': 'USDC.e - Optimism',
      '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48': 'USDC - Ethereum',
      '0x66a9893cC07D91D95644AEDD05D03f95e1dBA8Af':
        'Uniswap V4 Router - Etheruem',
      '0x1095692A6237d83C6a72F3F5eFEdb9A670C49223':
        'Uniswap V4 Router - Polygon',
      '0x0000000000000000000000000000000000000000': 'Zero/Null Address',
      '0x000000000000000000000000000000000000dEaD': 'Burn Address',
      '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D': 'Uniswap V2 Router',
      '0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45': 'Uniswap V3: Old Deployer',
      '0x3fC91A3afd70395Cd496C647d5a6CC9D4B2b7FAD': 'Uniswap Universal Router',
      '0xE592427A0AEce92De3Edee1F18E0157C05861564': 'Uniswap V3 Router',
      '0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F': 'SushiSwap Router',
      '0xDEF1C0ded9bec7F1a1670819833240f027b25EfF': '0x Exchange Proxy',
      '0x1111111254EEB25477B68fb85Ed929f73A960582': '1inch V5 Router',
      '0x881D40237659C251811CEC9c364ef91dC08D300C': 'Metamask Swap Router',
      '0x07d82CD44cd598ACf355Af8c8089b30b2a13B088':
        'Polymarket Withdrawal Block',
      '2ygdTkdUtN9PhoMko12bQi6PimJrqxcKmCvQGkCG6SN7':
        'Polymarket Withdrawal Block',
      '0xd40cBF452e8D6c9dF3e8bbE24eA8b65f859Ae34b':
        'Polymarket Withdrawal Block',
      GZxiVHg1JM6gCWRG7FwhaD6gPYpcLhiJ21s4ga7Ynfus:
        'Polymarket Withdrawal Block',
      '0xc0ad1a499149595a5aa093074b4d3523e6219326':
        'Polymarket Withdrawal Block',
      '0x204Cc209684AbAa9F3FAE64bdC9Ba0d8fB4C8fe1':
        'Polymarket Withdrawal Block',
      '0xE42640650C634ad300a47635856AafBbBA1d2222':
        'Polymarket Withdrawal Block',
      '0x51Cf782223289C05568F9F7Dede8CB1bC2f9c5Ca':
        'Polymarket Withdrawal Block',
      '0xC771A30a7c1aCA828eeEF7B822ac864a64cBaAe2':
        'Polymarket Withdrawal Block',
      '0x7BCECe0d8fd92ECCf39Bc35242c6D9aAc0aA75A6':
        'Polymarket Withdrawal Block',
      '0xe42640650c634ad300a47635856aafbbba1d2222':
        'Polymarket Withdrawal Block',
      '0xfa323e40632edca701abc6c8cf1f82175909bd9a':
        'Polymarket Withdrawal Block',
      '0x9E73d3f1b4233E6B5d6224B9234Cd26f98274904':
        'Polymarket Withdrawal Block',
    },
  },
  blockedcountries: {
    value: [
      'AF',
      'BY',
      'MM',
      'CF',
      'CU',
      'CD',
      'IR',
      'LB',
      'LY',
      'NI',
      'KP',
      'UA',
      'SO',
      'SS',
      'SY',
      'VE',
    ],
  },
  brokerage_hide_you_receive: {
    value: false,
  },
  chainidsortorder: {
    value: ['1', '1151111081099710', '8453', '56', '137', '42161', '10'],
  },
  chaininfobanners: {
    value: {},
  },
  checkoutgasbufferunits: {
    value: '1500000',
  },
  checkoutnotificationsrefreshinterval: {
    value: {
      listRefresh: 5000,
      itemRefresh: 2000,
    },
  },
  checkouttimeestimateoverrides: {
    value: {
      balance: 60,
      brokerage: 120,
      card: 300,
      token_transfer: 60,
    },
  },
  checkouttopannouncementbanner: {
    value: {
      title: '',
      subtitle: '',
      iconSrc: 'https://sdk-cdn.fun.xyz/images/announcement-icon-rounded.svg',
      chainIdList: [],
    },
  },
  connectwalletchainiconorder: {
    value: [1, 56, 8453, 137],
  },
  disabletokentransferchainsandassets: {
    value: {},
  },
  disablewithdrawalchainsandassets: {
    value: {},
  },
  dynamicrouting: {
    value: [
      {
        routeId: 'LIGHTER_ETH_SPOT',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: {
              chainId: '1',
              tokenAddress: '*',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
          {
            when: '*',
            use: {
              path: 'RL_TRANSFER',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_USDC_PERPS',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: {
              chainId: '1',
              tokenAddress: '*',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
          {
            when: '*',
            use: {
              path: 'RL_TRANSFER',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_USDC_SPOT',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: {
              chainId: '1',
              tokenAddress: '*',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
          {
            when: '*',
            use: {
              path: 'RL_TRANSFER',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_USDC_PERPS_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_USDC_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_ETH_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_LIT_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0x232CE3bd40fCd6f80f3d55A522d03f25Df784Ee2',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_LINK_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_UNI_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_AAVE_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_SKY_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0x56072C95FAA701256059aa122697B133aDEd9279',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_LDO_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_AZTEC_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0xA27EC0006e59f245217Ff08CD52A7E8b169E62D2',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
      {
        routeId: 'LIGHTER_XAUT_SPOT_NEW_USER',
        rules: [
          {
            when: {
              chainId: '1',
              tokenAddress: '0x68749665FF8D2d112Fa859AA293F07A622782F38',
            },
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
              badge: 'NATIVE',
            },
          },
          {
            when: '*',
            use: {
              path: 'FUN_MAINNET_DEPOSIT',
            },
          },
        ],
      },
    ],
  },
  enablebitcoin: {
    value: true,
  },
  enablebitcoinlightning: {
    value: false,
  },
  enablebluvobrokerage: {
    value: true,
  },
  enablecashapplightning: {
    value: false,
  },
  enablecashierformfactor: {
    value: false,
  },
  enablefiatdeposit: {
    variants: [
      {
        condition: {
          type: 'country',
          countryCodes: ['US'],
        },
        value: false,
      },
    ],
    value: true,
  },
  enablemeldpayment: {
    value: false,
  },
  enablesourcegrouplabels: {
    value: true,
  },
  enableswapped: {
    value: false,
  },
  enableswappeddeposit: {
    value: false,
  },
  enableswappedwithdrawal: {
    value: false,
  },
  enabletokentransfer: {
    value: true,
  },
  enabletokentransferuniversaldepositaddress: {
    value: true,
  },
  fiatv2regionpolicy: {
    value: {
      deny: [],
      allow: ['US'],
    },
  },
  foppriority: {
    variants: [
      {
        condition: {
          type: 'country',
          countryCodes: [
            'AD',
            'AE',
            'AM',
            'AT',
            'AU',
            'AW',
            'AZ',
            'CH',
            'CZ',
            'DE',
            'DK',
            'DM',
            'GA',
            'GB',
            'GG',
            'GL',
            'GP',
            'HU',
            'IE',
            'IT',
            'JE',
            'KN',
            'KW',
            'LU',
            'ME',
            'NL',
            'OM',
            'PG',
            'PL',
            'QA',
            'SA',
            'SE',
            'TW',
            'US',
            'UZ',
            'ZA',
          ],
        },
        value: [
          'APPLE_PAY',
          'NATIVE_CASH_APP_LIGHTNING',
          'CARDS',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['AR', 'GH', 'KE'],
        },
        value: [
          'ASTROPAY',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['LK', 'MO', 'SR', 'TM', 'VU', 'IN'],
        },
        value: [
          'GOOGLE_PAY',
          'CARDS',
          'APPLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['BR'],
        },
        value: [
          'PIX',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['CA'],
        },
        value: [
          'INTERAC',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['ID'],
        },
        value: [
          'GOPAY',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['MY'],
        },
        value: [
          'TOUCHNGO',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['NO'],
        },
        value: [
          'VIPPS',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['PH'],
        },
        value: [
          'GCASH',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['TH'],
        },
        value: [
          'PROMPTPAY',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['VN'],
        },
        value: [
          'VIETQR',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['ZM'],
        },
        value: [
          'MOBILE_MONEY',
          'CARDS',
          'APPLE_PAY',
          'GOOGLE_PAY',
          'REVOLUT_PAY',
          'PAYPAL',
          'BANK_TRANSFER',
          'PIX',
          'SKRILL',
        ],
      },
    ],
    value: [
      'CARDS',
      'APPLE_PAY',
      'NATIVE_CASH_APP_LIGHTNING',
      'GOOGLE_PAY',
      'REVOLUT_PAY',
      'PAYPAL',
      'BANK_TRANSFER',
      'PIX',
      'SKRILL',
    ],
  },
  freeusdcbanner: {
    value: {
      enabled: false,
      exactlySixChainIds: [1, 1151111081099710, 8453, 56, 137, 42161],
      depositEnabled: false,
      withdrawalEnabled: false,
    },
  },
  geoprovider: {
    value: 'off',
  },
  ischeckoutactivated: {
    value: true,
  },
  isfunuser: {
    value: false,
  },
  isrelaybypassenabled: {
    value: true,
  },
  lighterfasttransferaccountindex: {
    value: 731033,
  },
  maxcheckoutbypaymentmethod: {
    value: {
      account_balance: -1,
      bitcoin_lightning: 10000,
      default: -1,
    },
  },
  maxcheckoutusd: {
    value: -1,
  },
  meldquickoptions: {
    value: {
      USD: [100, 500, 1000],
      EUR: [90, 435, 870],
      JPY: [14500, 72500, 145000],
      KRW: [137500, 690000, 1380000],
      GBP: [75, 375, 745],
      CAD: [135, 685, 1365],
      AUD: [155, 770, 1540],
      CHF: [80, 410, 820],
      BRL: [550, 2750, 5500],
      INR: [8600, 43000, 86000],
      PHP: [5700, 28500, 57000],
      TRY: [3950, 19800, 39500],
      RUB: [7850, 39300, 78600],
      PLN: [370, 1860, 3715],
      SGD: [130, 645, 1285],
    },
  },
  mintokentransfervalue: {
    variants: [
      {
        condition: {
          type: 'country',
          countryCodes: ['CA'],
        },
        value: {
          default: 3,
          chains: {
            '1': 15,
            '8253038': 15,
            '728126428': 15,
          },
        },
      },
      {
        condition: {
          type: 'country',
          countryCodes: ['AU'],
        },
        value: {
          default: 3.5,
          chains: {
            '1': 15,
            '8253038': 15,
            '728126428': 15,
          },
        },
      },
    ],
    value: {
      default: 2.5,
      chains: {
        '1': 10,
        '8253038': 10,
        '728126428': 10,
      },
    },
  },
  newtokenassetselectionbanner: {
    value: {},
  },
  relaybypasssourcechainsandassets: {
    value: {
      '1': ['*'],
      '10': ['*'],
      '56': ['*'],
      '137': ['*'],
      '143': ['*'],
      '999': ['*'],
      '2741': ['*'],
      '8453': ['*'],
      '42161': ['*'],
      '747474': ['*'],
      '5064014': ['*'],
      '8253038': ['*'],
    },
  },
  relaybypasstargetchainsandassets: {
    value: {
      '1': ['*'],
      '10': ['*'],
      '56': ['*'],
      '137': ['*'],
      '143': ['*'],
      '999': ['*'],
      '1337': ['*'],
      '2741': ['*'],
      '8453': ['*'],
      '42161': ['*'],
      '747474': ['*'],
      '3586256': ['*'],
      '5064014': ['*'],
      '8253038': ['*'],
      '1151111081099710': ['*'],
    },
  },
  showinfobanner: {
    value: {
      message: '',
      expireAtMs: 0,
      type: 'alert',
    },
  },
  showpoweredtagline: {
    value: false,
  },
  stablecoinsymbols: {
    value: ['USDC', 'USDC.e', 'USDT', 'DAI', 'USDe', 'pUSD', 'USDG'],
  },
  supportedexchangesv2: {
    value: [],
  },
  swappeddefaultinputamount: {
    value: {
      fallbackUsd: 100,
      currencyOverrides: {
        USD: 100,
        EUR: 100,
      },
    },
  },
  swappedwithdrawalsourceoverrides: {
    value: [],
  },
  tokentransferchaingroups: {
    value: {
      popular: [],
    },
  },
  tokentransferconfig: {
    value: {
      priorityTokens: ['USDC', 'USDT'],
      chains: [
        {
          chainId: 1,
          assets: [
            {
              address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
            },
            {
              address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
            },
            {
              address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
            },
            {
              address: '0x455e53CBB86018Ac2B8092FdCd39d8444aFFC3F6',
            },
            {
              address: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0',
            },
            {
              address: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
            },
            {
              address: '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
            },
          ],
        },
        {
          chainId: 1151111081099710,
          assets: [
            {
              address: '11111111111111111111111111111111',
            },
            {
              address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
            },
            {
              address: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
            },
            {
              address: '6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN',
            },
            {
              address: 'DEkqHyPN7GMRJ5cArtQFAWefqbZb33Hyf6s5iCwjEonT',
            },
          ],
        },
        {
          chainId: 56,
          assets: [
            {
              address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
            },
            {
              address: '0x55d398326f99059fF775485246999027B3197955',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
            },
            {
              address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
            },
            {
              address: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
            },
            {
              address: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
            },
            {
              address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
            },
            {
              address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
            },
          ],
        },
        {
          chainId: 8453,
          assets: [
            {
              address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
            },
            {
              address: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
            },
            {
              address: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0x4200000000000000000000000000000000000006',
            },
            {
              address: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
            },
            {
              address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
            },
          ],
        },
        {
          chainId: 728126428,
          assets: [
            {
              address: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
            },
          ],
        },
        {
          chainId: 8253038,
          assets: [
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
          ],
        },
        {
          chainId: 42161,
          assets: [
            {
              address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
            },
            {
              address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
            },
            {
              address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
            },
            {
              address: '0x912CE59144191C1204E64559FE8253a0e49E6548',
            },
            {
              address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
            },
          ],
        },
        {
          chainId: 137,
          isDefault: true,
          assets: [
            {
              address: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
            },
            {
              address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
            },
            {
              address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
            },
            {
              address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
            },
          ],
        },
        {
          chainId: 999,
          assets: [
            {
              address: '0xb88339CB7199b77E23DB6E890353E22632Ba630f',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
            },
            {
              address: '0x9FDBdA0A5e284c32744D2f17Ee5c74B284993463',
            },
            {
              address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
            },
          ],
        },
        {
          chainId: 4663,
          assets: [
            {
              address: '0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
          ],
        },
        {
          chainId: 10,
          assets: [
            {
              address: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
            },
            {
              address: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
            },
            {
              address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0x4200000000000000000000000000000000000006',
            },
            {
              address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
            },
          ],
        },
      ],
    },
  },
  tokentransfertokengroups: {
    value: {
      popular: [],
      stablecoins: [],
    },
  },
  uda_params: {
    value: [
      {
        dynamicRoutingId: 'LIGHTER_ETH_SPOT',
        params: {
          targetChain: '3586256',
          targetAsset: '0x0000000000000000000000000000000000000001',
          targetAssetTicker: 'ETH',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/eth.svg',
          qrcodeActionType: 'LIGHTER_SPOT',
          defaultChainId: '1',
          defaultTokenSymbol: 'ETH',
        },
      },
      {
        dynamicRoutingId: 'LIGHTER_ETH_SPOT_NEW_USER',
        params: {
          targetChain: '1',
          targetAsset: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
          targetAssetTicker: 'ETH',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/eth.svg',
          qrcodeActionType: 'LIGHTER_SPOT',
          defaultChainId: '1',
          defaultTokenSymbol: 'ETH',
        },
      },
      {
        dynamicRoutingId: 'LIGHTER_USDC_PERPS',
        params: {
          targetChain: '3586256',
          targetAsset: '0x0000000000000000000000000000000000000000',
          targetAssetTicker: 'USDC',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/usdc.svg',
          qrcodeActionType: 'LIGHTER_PERPS',
          defaultChainId: '42161',
          defaultTokenSymbol: 'USDC',
        },
      },
      {
        dynamicRoutingId: 'LIGHTER_USDC_PERPS_NEW_USER',
        params: {
          targetChain: '1',
          targetAsset: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
          targetAssetTicker: 'USDC',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/usdc.svg',
          qrcodeActionType: 'LIGHTER_PERPS',
          defaultChainId: '42161',
          defaultTokenSymbol: 'USDC',
        },
      },
      {
        dynamicRoutingId: 'LIGHTER_USDC_SPOT',
        params: {
          targetChain: '3586256',
          targetAsset: '0x0000000000000000000000000000000000000003',
          targetAssetTicker: 'USDC',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/usdc.svg',
          qrcodeActionType: 'LIGHTER_SPOT',
          defaultChainId: '42161',
          defaultTokenSymbol: 'USDC',
        },
      },
      {
        dynamicRoutingId: 'LIGHTER_USDC_SPOT_NEW_USER',
        params: {
          targetChain: '1',
          targetAsset: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
          targetAssetTicker: 'USDC',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/usdc.svg',
          qrcodeActionType: 'LIGHTER_SPOT',
          defaultChainId: '42161',
          defaultTokenSymbol: 'USDC',
        },
      },
      {
        dynamicRoutingId: 'MALLARD_USDG_PERPS',
        params: {
          targetChain: '4663',
          targetAsset: '0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168',
          targetAssetTicker: 'USDG',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/usdg.svg',
          qrcodeActionType: 'MALLARD_PERPS',
        },
      },
      {
        dynamicRoutingId: 'MALLARD_USDG_SPOT',
        params: {
          targetChain: '4663',
          targetAsset: '0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168',
          targetAssetTicker: 'USDG',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/usdg.svg',
        },
      },
      {
        dynamicRoutingId: 'POLYMARKET_PERPS',
        params: {
          targetChain: '137',
          targetAsset: '0xC011a7E12a19f7B1f670d46F03B03f3342E82DFB',
          targetAssetTicker: 'pUSD',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/pusd.svg',
          qrcodeActionType: 'POLYMARKET_PERPS_DEPOSIT',
          defaultChainId: '1',
          defaultTokenSymbol: 'USDC',
        },
      },
      {
        dynamicRoutingId: 'POLYMARKET_PREDICTIONS',
        params: {
          targetChain: '137',
          targetAsset: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
          targetAssetTicker: 'USDC',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/usdc.svg',
          defaultChainId: '1',
          defaultTokenSymbol: 'USDC',
        },
      },
      {
        dynamicRoutingId: 'NADO_USDT0_PERPS',
        params: {
          targetChain: '57073',
          targetAsset: '0x0200C29006150606B650577BBE7B6248F58470c1',
          targetAssetTicker: 'USDT0 (Perps)',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/usdt.svg',
          defaultChainId: '57073',
          defaultTokenSymbol: 'USDT',
        },
      },
      {
        dynamicRoutingId: 'NADO_KBTC_SPOT',
        params: {
          targetChain: '57073',
          targetAsset: '0x73E0C0d45E048D25Fc26Fa3159b0aA04BfA4Db98',
          targetAssetTicker: 'kBTC (Spot)',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/kbtc.svg',
          defaultChainId: '57073',
          defaultTokenSymbol: 'kBTC',
        },
      },
      {
        dynamicRoutingId: 'NADO_WETH_SPOT',
        params: {
          targetChain: '57073',
          targetAsset: '0x4200000000000000000000000000000000000006',
          targetAssetTicker: 'WETH (Spot)',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/weth.svg',
          defaultChainId: '57073',
          defaultTokenSymbol: 'WETH',
        },
      },
      {
        dynamicRoutingId: 'NADO_USDC_SPOT',
        params: {
          targetChain: '57073',
          targetAsset: '0x2D270e6886d130D724215A266106e6832161EAEd',
          targetAssetTicker: 'USDC (Spot)',
          iconSrc: 'https://sdk-cdn.fun.xyz/images/usdc.svg',
          defaultChainId: '57073',
          defaultTokenSymbol: 'USDC',
        },
      },
    ],
  },
  withdrawalconfig: {
    value: {
      priorityTokens: ['USDC', 'USDT'],
      chains: [
        {
          chainId: 1,
          assets: [
            {
              address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
            },
            {
              address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
            },
            {
              address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
            },
            {
              address: '0x455e53CBB86018Ac2B8092FdCd39d8444aFFC3F6',
            },
            {
              address: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0',
            },
            {
              address: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
            },
            {
              address: '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
            },
          ],
        },
        {
          chainId: 1151111081099710,
          assets: [
            {
              address: '11111111111111111111111111111111',
            },
            {
              address: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
            },
            {
              address: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
            },
          ],
        },
        {
          chainId: 56,
          assets: [
            {
              address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
            },
            {
              address: '0x55d398326f99059fF775485246999027B3197955',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
            },
            {
              address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
            },
            {
              address: '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
            },
            {
              address: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
            },
            {
              address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
            },
            {
              address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
            },
          ],
        },
        {
          chainId: 728126428,
          assets: [
            {
              address: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
            },
          ],
        },
        {
          chainId: 8453,
          assets: [
            {
              address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
            },
            {
              address: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
            },
            {
              address: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0x4200000000000000000000000000000000000006',
            },
            {
              address: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
            },
            {
              address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
            },
          ],
        },
        {
          chainId: 137,
          assets: [
            {
              address: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
            },
            {
              address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
            },
            {
              address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
            },
            {
              address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
            },
          ],
        },
        {
          chainId: 42161,
          assets: [
            {
              address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
            },
            {
              address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
            },
            {
              address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
            },
            {
              address: '0x912CE59144191C1204E64559FE8253a0e49E6548',
            },
            {
              address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
            },
          ],
        },
        {
          chainId: 10,
          assets: [
            {
              address: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
            },
            {
              address: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
            },
            {
              address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
            },
            {
              address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            },
            {
              address: '0x4200000000000000000000000000000000000006',
            },
            {
              address: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
            },
          ],
        },
      ],
    },
  },
  withdrawalinfobanner: {
    value: {
      message: '',
      expireAtMs: 0,
      type: 'alert',
    },
  },
} as const
